import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ImgErrorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 50 70">
      <rect width="50" height="70" rx="8" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45 12C45 14.2091 43.2091 16 41 16C38.7909 16 37 14.2091 37 12C37 9.79086 38.7909 8 41 8C43.2091 8 45 9.79086 45 12ZM42.9725 35H6.91117C6.10161 35 5.63982 34.0882 6.10486 33.4256L18.9183 15.1664C19.3165 14.599 20.1572 14.599 20.5554 15.1664L27.4268 24.9582C27.7991 25.4887 28.5698 25.5304 28.9971 25.0432L32.62 20.9132C33.035 20.4401 33.7787 20.4634 34.1633 20.9616L43.7564 33.3889C44.2638 34.0463 43.8029 35 42.9725 35ZM7 43C6.44771 43 6 43.4477 6 44C6 44.5523 6.44771 45 7 45H43C43.5523 45 44 44.5523 44 44C44 43.4477 43.5523 43 43 43H7ZM6 51C6 50.4477 6.44771 50 7 50H43C43.5523 50 44 50.4477 44 51C44 51.5523 43.5523 52 43 52H7C6.44771 52 6 51.5523 6 51ZM7 57C6.44771 57 6 57.4477 6 58C6 58.5523 6.44771 59 7 59H29C29.5523 59 30 58.5523 30 58C30 57.4477 29.5523 57 29 57H7Z"
        fill="#E0E0E0"
      />
    </SvgIcon>
  );
};
